module.exports = __webpack_public_path__ + "static/media/xrp.eeead9b5.svg";